// extracted by mini-css-extract-plugin
export default {"noData":"humanTeam_noData__+FlTO"};